import { ArrowUp } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { scrollToId } from "@/lib/anim";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Manifesto", href: "#manifesto" },
  { label: "Process", href: "#process" },
  { label: "Work", href: "#work" },
  { label: "Contact", href: "#contact" },
];

export const Footer = () => {
  return (
    <footer
      className="relative bg-[#050505] border-t border-white/10 pt-20 pb-10"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <div>
            <div className="flex items-center gap-3">
              <img src="/mobyle-logo.png" alt="Mobyle" className="h-11 w-auto object-contain" />
              <span className="font-heading font-extrabold text-2xl tracking-tight text-white">
                Mobyle
              </span>
            </div>
            <p className="mt-5 max-w-sm text-white/50 leading-relaxed">
              Custom websites, apps & AI automations. Built to spec — not to a
              theme.
            </p>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {LINKS.map((l) => (
              <button
                key={l.href}
                onClick={() => scrollToId(l.href)}
                className="text-sm text-white/60 hover:text-teal transition-colors duration-300"
                data-testid={`footer-nav-${l.label.toLowerCase()}`}
              >
                {l.label}
              </button>
            ))}
          </nav>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="text-sm text-white/40">
            © {new Date().getFullYear()} Mobyle. All rights reserved.
          </span>
          <div className="flex items-center gap-6">
            <Link
              to="/privacy"
              className="text-sm text-white/50 hover:text-teal transition-colors duration-300"
              data-testid="footer-privacy-link"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-sm text-white/50 hover:text-teal transition-colors duration-300"
              data-testid="footer-terms-link"
            >
              Terms of Service
            </Link>
            <button
              onClick={() => scrollToId("#top")}
              className="group inline-flex items-center gap-2 text-sm text-white/60 hover:text-teal transition-colors duration-300"
              data-testid="footer-back-to-top"
            >
              Back to top
              <ArrowUp
                size={16}
                className="group-hover:-translate-y-1 transition-transform duration-300"
              />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};
